import { v4 as uuidv4 } from 'uuid';

export function GiftText(props) {
	return {
		componentName: 'GiftText',
		componentId: uuidv4(),
		props,
		childrenComponents: [],
	};
}
